export type AcquisitionAction =
  | 'batch-download'
  | 'buy-ultra-pack'
  | 'cart'
  | 'contact-us-market-freeze'
  | 'download'
  | 'modified-download'
  | 'modified-license-redownload'
  | 'modified-download-completed'
  | 'view-ultra-pack-upsell'
  | 'view-pricing-options'
  | 'select-options'
  | 'save-to-cart'
  | 'view-cart'
  | 'request-preview'
  | 'return-to-royalty-free'
  | 'chat-sign-in'
  | 'chat-with-us'
  | 'proceed-to-checkout'
  | 'get-with-ultrapack'
  | 'return-to-modified-royalty-free'
  | 'subscription-download'
  | 'subscription-subscribe'
  | 'subscription-add-to-cart'
  | 'subscription-buy-now'
  | 'subscription-links';

const acquisitionActions: Record<string, AcquisitionAction> = {
  BATCH_DOWNLOAD: 'batch-download',
  BUY_ULTRA_PACK: 'buy-ultra-pack',
  CART: 'cart',
  CONTACT_US_MARKET_FREEZE: 'contact-us-market-freeze',
  DOWNLOAD: 'download',
  MODIFIED_DOWNLOAD: 'modified-download',
  MODIFIED_LICENSE_REDOWNLOAD: 'modified-license-redownload',
  MODIFIED_DOWNLOAD_COMPLETED: 'modified-download-completed',
  VIEW_ULTRA_PACK_UPSELL: 'view-ultra-pack-upsell',
  VIEW_PRICING_OPTIONS: 'view-pricing-options',
  SELECT_OPTIONS: 'select-options',
  SAVE_TO_CART: 'save-to-cart',
  VIEW_CART: 'view-cart',
  REQUEST_PREVIEW: 'request-preview',
  RETURN_TO_ROYALTY_FREE: 'return-to-royalty-free',
  RETURN_TO_MODIFIED_ROYALTY_FREE: 'return-to-modified-royalty-free',
  CHAT_SIGN_IN: 'chat-sign-in',
  CHAT_WITH_US: 'chat-with-us',
  PROCEED_TO_CHECKOUT: 'proceed-to-checkout',
  GET_WITH_ULTRAPACK: 'get-with-ultrapack',
  SUBSCRIPTION_DOWNLOAD: 'subscription-download',
  SUBSCRIPTION_SUBSCRIBE: 'subscription-subscribe',
  SUBSCRIPTION_ADD_TO_CART: 'subscription-add-to-cart',
  SUBSCRIPTION_BUY_NOW: 'subscription-buy-now',
  SUBSCRIPTION_LINKS: 'subscription-links',
};

export default acquisitionActions;
